<template>
  <div class="top" style="">
    <div class="logo">
      <router-link to='/Index'><img src="../assets/logo.png"></router-link>
    </div>
    <div style="margin-top: 18px;color: white;margin-right: 20px"><span style="font-size: 12px">切换到公共服务平台:</span>
      <Icon type="md-swap" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'QyHeader',
  data() {
    return {
      
    }
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/QyHeader.vue